import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import { storeToRefs } from "pinia";
import { useActivityStore } from "@/stores/activityStore";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { faCheckSquare, faTrash, faThumbtack } from "@fortawesome/free-solid-svg-icons";
import DelayedInput from "@/components/Common/DelayedInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivitySettings',
    setup(__props) {
        library.add({
            faCheckSquare,
            faSquare,
            faTrash,
            faThumbtack,
        });
        const activityStore = useActivityStore();
        const { activities } = storeToRefs(activityStore);
        const query = ref("");
        const filteredActivities = computed(() => {
            if (query.value.length > 0) {
                const queryLower = query.value.toLowerCase();
                const results = activities.value.filter((a) => {
                    const attributeValues = [a.title, a.description];
                    for (const value of attributeValues) {
                        if (value.toLowerCase().indexOf(queryLower) !== -1) {
                            return true;
                        }
                    }
                    return false;
                });
                return results;
            }
            else {
                return activities.value;
            }
        });
        const foundActivities = computed(() => {
            return filteredActivities.value.length > 0;
        });
        function onClick(activity) {
            if (activity.optional) {
                activity.visible = !activity.visible;
            }
        }
        function onRemove(activity) {
            activityStore.remove(activity.id);
        }
        function onQuery(newQuery) {
            query.value = newQuery;
        }
        return { __sfc: true, activityStore, activities, query, filteredActivities, foundActivities, onClick, onRemove, onQuery, FontAwesomeIcon, DelayedInput };
    }
});
